/**
 * This function returns a function that when given an event handler, it will call it
 * and, if the event wasn't prevented in the handler, will call the callback handler.
 * A good use case is when you want to allow a component to receive an external
 * prop to handle an event (ex: onChange) but you also want to perform some logic on
 * the same event
 * @param handler external event handler
 * @param callback callback event handler
 * @template {React.SyntheticEvent} TEvent
 */
export function wrapEvent(handler, callback) {
  return function (event) {
    handler && handler(event);

    if (!event.defaultPrevented) {
      return callback && callback(event);
    }
  };
}
/**
 * Converts a numeric value
 */

export var toPx = function toPx(value) {
  return !isNaN(value) ? "".concat(value, "px") : value;
};
/**
 * Generates a simple cryptographically weak id based on a prefix. Good for making sure
 * an element id or label is unique
 * @param prefix prefix for the id
 */

export function genId(prefix) {
  // This should be a noop in tests
  if (process.env.NODE_ENV === 'test') {
    return prefix;
  }

  return "".concat(prefix, "-").concat(Math.random().toString(32).substr(2, 8));
}
/**
 * Determines if the given url is absolute. Useful for deciding if a url is intended to
 * lead to a local or external page.
 * @param url string being checked
 */

export function isUrlAbsolute(url) {
  if (typeof url !== 'string') {
    return false;
  }

  return url.indexOf('://') > 0 || url.indexOf('//') === 0 || url.indexOf('mailto:') === 0;
}
/**
 * Returns the parent of an element based on the number of levels;
 * @param el: base HTMLElement to get parent
 * @param levels: number of parent levels (default is 1)
 */

export var getParentElement = function getParentElement(el, levels) {
  if (typeof levels !== 'number') levels = 1;
  var parentEl = el;

  while (levels) {
    parentEl = parentEl && parentEl.parentElement;
    levels--;
  }

  return parentEl;
};